module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker6-api.relevant-digital.com/"}};